/* eslint-disable import/no-unresolved */
import React, { memo, useCallback } from 'react';
import PercentageIcon from 'images/orders/percentage.svg';

import LineItemTotal from './LineItemTotal';
import SelectedProductWithImage from './SelectedProductWithImage';

import CheckBoxMC from '../../../../../components/CheckBoxMC';
import IconMC from '../../../../../components/IconMC';

import InputComponent from '../../../../../components/InputMC';
import OrderProductPriceLabel from '../../../OrderProductPriceLabel';
import CurrencyInputMC from '../../../../../components/CurrencyInputMC';

const ProductRow = memo(({
  product,
  productIndex,
  currencySymbol,
  currency,
  selectOrderItem,
  handleInputEdit,
  setEditTax,
  openProductDiscount,
  removeProduct
}) => {
  const handleWholesaleChange = useCallback((e) => {
    selectOrderItem(e, product);
  }, [selectOrderItem, product]);

  const handleAmountInput = useCallback((e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  }, []);

  const handleSaveTax = useCallback(() => {
    setEditTax(product, false);
  }, [setEditTax, product]);

  const handleEditTax = useCallback(() => {
    setEditTax(product, true);
  }, [setEditTax, product]);

  const handleDiscountClick = useCallback(() => {
    openProductDiscount(product);
  }, [openProductDiscount, product]);

  const handleRemoveClick = useCallback(() => {
    removeProduct(product);
  }, [removeProduct, product]);

  return (
    <div className="tw-grid tw-grid-cols-[40px_minmax(230px,1fr)_140px_160px_repeat(2,140px)_minmax(140px,auto)] tw-items-center tw-border-b">
      <div className="tw-pl-4 tw-py-2.5">
        <CheckBoxMC
          key={`wholesale_price-${product.lineIdentifier}`}
          checked={product.selected}
          onChange={handleWholesaleChange}
          className="tw-w-3 tw-h-3"
        />
      </div>
      <div className="tw-px-4 tw-py-2.5">
        <SelectedProductWithImage product={product} />
      </div>

      <div className="tw-flex tw-justify-end tw-px-2 tw-py-2.5">
        <InputComponent
          key={`amount-${product.lineIdentifier}`}
          name={`selectedProducts.${productIndex}.quantity`}
          onInput={handleAmountInput}
          onChange={(name, value) => handleInputEdit({ target: { name, value } }, product)}
          className="tw-py-2 tw-text-right"
          containerClass="!tw-w-[160px]"
        />
      </div>

      <div className="tw-flex tw-justify-end tw-px-2 tw-py-2.5">
        <div className="tw-w-[160px]">
          <OrderProductPriceLabel
            key={`unit-price-${product.lineIdentifier}`}
            product={product}
            fieldName={`selectedProducts.${productIndex}.unit_price`}
            handleInputEdit={handleInputEdit}
          />
        </div>
      </div>

      <div className="tw-px-4 tw-py-2.5 tw-flex tw-items-center">
        {product.editableCustomTax
          ? (
            <div className="tw-flex tw-items-center tw-gap-1">
              <div className="tw-flex tw-w-[70px]">
                <CurrencyInputMC
                  key={`custom-tax-${product.lineIdentifier}`}
                  name={`selectedProducts.${productIndex}.custom_tax`}
                  onChange={(e) => handleInputEdit(e, product)}
                />
              </div>
              <IconMC
                name="save-icon"
                onClick={handleSaveTax}
                className="tw-text-gray-700"
                size="lg"
              />
            </div>
          )
          : (
            <>
              <span className="tw-mr-[5px] tw-mt-2">
                {product.custom_tax || 0}
                {' '}
                %
              </span>
              <IconMC
                name="edit-outline"
                onClick={handleEditTax}
                className="tw-text-gray-700"
                size="xl"
              />
            </>
          )}
      </div>

      <div className="tw-text-right tw-px-4 tw-py-2.5">
        <LineItemTotal
          product={product}
          currencySymbol={currencySymbol}
          currency={currency}
        />
      </div>

      <div className="tw-px-4 tw-py-2.5">
        <div className="tw-flex tw-justify-end">
          <div className="tw-relative tw-inline-block">
            <span className="tw-mr-2.5 tw-rounded-[13px] tw-w-7.5 tw-h-7.5 tw-cursor-pointer" onClick={handleDiscountClick}>
              <img src={PercentageIcon} alt="" className="tw-w-5" />
            </span>
          </div>
          <IconMC
            name="trash-2-outline"
            onClick={handleRemoveClick}
            className="tw-text-gray-700"
            size="xl"
          />
        </div>
      </div>
    </div>
  );
});

const ProductsTable = ({
  currencySymbol,
  currency,
  selectedProducts,
  handleInputEdit,
  changePriceToWholesalePrice,
  setEditTax,
  openProductDiscount,
  removeProduct,
  selectOrderItem
}) => (selectedProducts
  .filter((el) => el._destroy !== true)
  .map((product, index) => (
    <ProductRow
      key={product.lineIdentifier}
      product={product}
      productIndex={index}
      currencySymbol={currencySymbol}
      currency={currency}
      changePriceToWholesalePrice={changePriceToWholesalePrice}
      handleInputEdit={handleInputEdit}
      setEditTax={setEditTax}
      openProductDiscount={openProductDiscount}
      removeProduct={removeProduct}
      selectOrderItem={selectOrderItem}
    />
  )));

export default memo(ProductsTable);
